<template>
	<a class="card-wrapper" :href="item.url">
		<div
			class="product-card"
			:class="[{ discounted: item.product.compare_at_price }]"
		>
			<h3 v-html="item.metafields.designer"></h3>
			<h4 class="title" v-html="item.product.title"></h4>
			<div class="img-wrapper" ref="cardImage">
				<img
					v-if="mounted"
					ref="img"
					class="featured lazyload"
					:data-src="item.metafields.image_primary"
				/>

				<img
					v-if="mounted"
					class="hover lazyload"
					:data-src="item.metafields.image_secondary"
				/>
			</div>
			<div class="price-wrapper" v-if="showPrice">
				<p class="price-before" v-if="item.product.compare_at_price">
					{{ $formatMoney(item.product.compare_at_price) }}
				</p>
				<p :class="['price', { discounted: item.product.compare_at_price }]">
					{{ $formatMoney(item.product.price) }}
				</p>
			</div>
		</div>
	</a>
</template>

<script>
	import responsiveImage from "./responsive-image.vue";

	export default {
		props: {
			item: { required: true, type: Object }
		},
		components: {
			responsiveImage
		},
		data() {
			return {
				mounted: false
			};
		},
		watch: {
			item: function () {
				this.$refs.img.classList.add("lazyload");
			}
		},
		computed: {
			showPrice() {
				// my brain didn't work enough to make this look smarter
				if (this.item.metafields.out_of_stock_policy === "promote") {
					return this.item.product.available;
				} else {
					return true;
				}
			}
		},
		mounted() {
			this.mounted = true;
		}
	};
</script>

<style lang="scss" scoped>
	a.card-wrapper {
		@include ie {
			margin: 10px;
			max-width: 23%;
			width: 100%;
		}
	}
	.product-card {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		font-size: 15px;
		color: $dark-grey;
		padding: 10px 25px;
		background-color: $grey;
		transition: all 0.2s ease-out;
		height: 100%;

		&.discounted {
			background-color: #6a6a79;

			h3,
			h4,
			p {
				color: #fff !important;
			}
		}

		@include res(tab-p) {
			width: 100%;
		}

		.img-wrapper {
			width: 100%;
			padding-top: 100%;
			overflow: hidden;
			margin-bottom: 70px;
			position: relative;

			@include res(tab-p) {
				margin-bottom: 30px;
			}

			img {
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				position: absolute;
				transition: all 0.1s ease-in-out;
				opacity: 0;
				&.hover {
					opacity: 0;
					visibility: hidden;
				}

				&.lazyloaded {
					opacity: 1;
					transition: opacity 250ms ease-in;
				}
			}
		}

		&:hover {
			.img-wrapper::after {
				background-color: transparent;
				transition: background-color 0.3s linear;
			}
			img.hover {
				opacity: 1;
				visibility: visible;
			}
			img.featured {
				opacity: 0;
				visibility: hidden;
			}
		}

		h3 {
			color: $dark-grey;
			font-size: 10px;
			font-family: $font-text-heavy;
			font-weight: lighter;
			line-height: 12px;
			align-self: flex-start;
			text-transform: uppercase;
		}

		h4.title {
			margin-bottom: 50px;
			align-self: flex-start;
			font-size: 10px;
			font-weight: 500;
			line-height: 12px;
			font-family: $font-text;
			text-align: left;

			@include res(tab-p) {
				margin-bottom: 30px;
			}
		}

		.price-wrapper {
			text-align: right;
			margin-left: auto;
		}

		p.price,
		p.price-before {
			display: block;
			margin-bottom: 5px;
			color: #595959;
			align-self: flex-end;
			font-size: 10px;
			font-weight: 500;
			line-height: 12px;

			&.discounted {
				font-family: $font-text-heavy;
				font-size: 16px;
			}
		}

		p.price-before {
			text-decoration: line-through;
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 300ms ease;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
</style>
